import { axiosInstance } from "api/axios-config/axios-config";
import {
  IAddOrderItem,
  IOrderItemProperties,
  IUpdateOrderItem,
  IUpdateStatus,
} from "mobx-stores/_models/orders/order-item";
import { BaseBussiness } from "../base";

class OrderItemBusiness extends BaseBussiness<
  IOrderItemProperties,
  IAddOrderItem,
  IUpdateOrderItem,
  IOrderItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public manageItemStatus = async (
    orderItemId: string,
    data: IUpdateStatus
  ) => {
    try {
      var res = await axiosInstance.put(
        `${this.url}/${orderItemId}/manage-item`,
        data
      );
      return res.data;
    } catch (error) {
      console.error("Fail manageItemStatus", error);
      return Promise.reject(error);
    }
  };
  public updateItemPrice = async (orderItemId: string, unitPrice: number) => {
    try {
      var res = await axiosInstance.put(
        `${this.url}/${orderItemId}/price`,
        undefined,
        {
          params: {
            price: unitPrice,
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateItemPrice", error);
      return Promise.reject(error);
    }
  };
}

export const orderItemBusiness = new OrderItemBusiness(
  "/api/app/purchase-order-item"
);
